import {Injectable} from '@angular/core';
import {IApiButtonConfig, IButtonConfig, IButtonTemplate} from "./button";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class ButtonService {

    /**
     * API URL
     */
    private API_URL: string;

    /**
     * PREFIX URL
     */
    private readonly PREFIX_URL: string = '/button';

    /**
     * CONFIG URL
     */
    private readonly CONFIG_URL: string = '/config';

    private _config: IButtonConfig;

    /**
     * @param _http
     */
    constructor(private _http: HttpClient) {

    }

    /**
     * Définit l'URL d'accès à l'API
     *
     * @param apiUrl
     */
    public setApiUrl(apiUrl: string): void {

        this.API_URL = apiUrl;
    }

    configLoaded(): boolean {

        return (typeof this._config !== 'undefined');
    }

    setConfig(config: IButtonConfig): void {

        this._config = config;
    }

    /**
     * Retourne la configuration nécessaire au chargement d'une page
     *
     * @returns {Observable<IApiButtonConfig>}
     */
    loadConfig(): Observable<IApiButtonConfig> {

        return this._http.get<IApiButtonConfig>(`${this.API_URL}${this.PREFIX_URL}${this.CONFIG_URL}`);
    }

    getConfig(): IButtonConfig {

        return this._config;
    }

    get templates(): IButtonTemplate[] {

        return this._config.templates;
    }
}
